export default __webpack_public_path__ + "static/media/chocolate-liquid.3776fe7b.png";